import { IOfferScopeListTableLang } from '../../../types/lang'

export const offerScopeListTableLang: IOfferScopeListTableLang = {
	offer_scope_list_table: {
		column_id: 'ID_ua',
		column_name: 'Name_ua',
		column_offer_id: 'Offer ID_ua',
		column_notes: 'Notes_ua',
		column_affiliate_network: 'Affiliate Network_ua',
		column_country: 'Country_ua',
		column_sales_cap: 'Sales/Cap_ua',
		column_diff: 'Diff_ua',
		column_cap_type: 'Type_ua',
		column_status: 'Status_ua',
	}
}